import QuizLesson from './QuizLesson'

export default QuizLesson
